import { PublicPageLoader } from '@/features/public-pages/components/PublicPageLoader';

/**
 * Public marketing home page (`/`), fully CMS-driven (MYN-197). Every section
 * renders from the `home` page's content via the public read API - no
 * hardcoded copy lives here. Loading/not-published/error states are shared
 * across every public page via `PublicPageLoader`.
 */
export function HomePage() {
  return <PublicPageLoader slug="home" />;
}
